import React from 'react';
import { VehicleType } from '../../types/userList';
import Button from '../Button';
import DateRangePicker from './DateRangePicker';
import Loader from 'react-js-loader'

interface TripFiltersProps {
  filters: {
    vehicleType: string;
    date?: string;
    limit: number;
    offset: number;
  };
  vehicleTypes: VehicleType[];
  onFilterChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, field: string) => void;
  onExportClick: () => void;
  hasData: boolean;
  t: (key: string) => string;
  onDateRangeSearch?: (startDate: string, endDate: string) => void;
  onClearFilters?: () => void;
  resetCounter?: number;
  isLoading:boolean // New prop to pass resetKey
}

const TripFilters: React.FC<TripFiltersProps> = ({
  filters,
  vehicleTypes,
  onFilterChange,
  onExportClick,
  hasData,
  t,
  onDateRangeSearch,
  onClearFilters,
  resetCounter = 0,
  isLoading
}) => {
  const handleDateRangeSearch = (startDate: string, endDate: string) => {
    if (onDateRangeSearch) {
      onDateRangeSearch(startDate, endDate);
    }
  };

  const handleClearClick = () => {
    if (onClearFilters) {
      onClearFilters();
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-between flex-row mb-2 selecterInput">
      <div className="d-flex gap-2 w-20 flex-column">
      <button
          className="btn btn-success w-35"
          onClick={onExportClick}
          disabled={!hasData}
          style={{
            opacity: !hasData ? 0.5 : 1,
            cursor: !hasData ? 'not-allowed' : 'pointer'
          }}
        >
          {isLoading ? (
            <Loader
              type="bubble-scale"
              bgColor={'#FFFFFF'}
              color={'#FFFFFF'}
              size={20}
            />
          ) : (
            t('Export_Data')
          )}
        </button>
        <Button
          onButtonClick={handleClearClick}
          title={t('clear')}
          style={{
            backgroundColor: '#dc3545',
            color: 'white',
            height: '52px'
          }}
        />
      </div>

      <div className="d-flex align-items-center justify-content-end flex-row mb-2 clock w-100 inputselect">
        <DateRangePicker
          t={t}
          filters={filters}
          onFilterChange={onFilterChange}
          vehicleType={filters.vehicleType}
          onSearch={handleDateRangeSearch}
          onDateRangeChange={handleDateRangeSearch}
          resetKey={resetCounter}
        />
        <div className="custom-select inputGagbage">
          <select
            className="selectInput"
            id="serviceDropdown"
            name={t('serviceType')}
            style={{
              padding: '11px 11px 11px 10px',
              background: 'white'
            }}
            value={filters.vehicleType}
            onChange={(e) => onFilterChange(e, 'vehicleType')}
            required
          >
            <option value="">{t('SelectType')}</option>
            {Array.isArray(vehicleTypes) &&
              vehicleTypes.map((type) => (
                <option
                  key={type.cost_center_id}
                  value={type.cost_center_id}
                >
                  {type.vehicle_type?.toUpperCase()}
                </option>
              ))}
          </select>
          <span className="custom-arrow"></span>
        </div>
      </div>
    </div>
  );
};

export default TripFilters;